export default [
  {
    header: 'Follow up',
    icon: 'GridIcon',
    route: 'follow-up',
    title: 'Follow up'
  },
]
